import { connect } from "react-redux";

import ProfilePage from "../components/ProfilePage";

import {
	disableUser,
	resetSaveMessage,
	updatePassword,
	updateProfile,
} from "shared-frontend/redux/actions/user";
import {
	getUserEmail,
	getUserFirstName,
	getUserLastName,
} from "shared-frontend/redux/selectors/user/data/profile";
import {
	getSaveEmailError,
	isProfilePageDeleting,
	isProfilePageSaved,
	isProfilePageSaving,
} from "shared-frontend/redux/selectors/user/profilePage";
import {
	getPasswordResetError,
	isPasswordResetSending,
	isPasswordResetSent,
} from "shared-frontend/redux/selectors/user/passwordReset";


export const mapStateToProps = ( state ) => {
	return {
		email: getUserEmail( state ),
		userFirstName: getUserFirstName( state ),
		userLastName: getUserLastName( state ),

		isSaving: isProfilePageSaving( state ),
		isSaved: isProfilePageSaved( state ),
		isDeleting: isProfilePageDeleting( state ),
		saveEmailError: getSaveEmailError( state ),

		isSavingPassword: isPasswordResetSending( state ),
		passwordIsSaved: isPasswordResetSent( state ),
		passwordResetError: getPasswordResetError( state ),
	};
};

export const mapDispatchToProps = ( dispatch ) => {
	return {
		onSaveProfile: ( profile ) => {
			dispatch( updateProfile( profile ) );
		},
		onSavePassword: ( password ) => {
			dispatch( updatePassword( password ) );
		},
		resetSaveMessage: () => {
			dispatch( resetSaveMessage() );
		},
		onDeleteProfile: () => {
			// eslint-disable-next-line
			if ( window.confirm( "WARNING! This action CANNOT be undone.\n\n" +
				"If you continue, you will lose access to your downloads and will no longer receive updates to" +
				" the premium plugins you've bought from Yoast.\n\nAre you sure you want to delete your Yoast account?" ) ) {
				dispatch( disableUser() );
			}
		},
	};
};

export const mergeProps = ( stateProps, dispatchProps, ownProps ) => {
	return Object.assign( {}, ownProps, stateProps, dispatchProps, {} );
};

const ProfilePageContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps,
)( ProfilePage );

export default ProfilePageContainer;
